module.exports = __webpack_public_path__ + "img/location-icon.04983aeb.svg";